export default "__VITE_ASSET__c05e0bd1__"